import { Button } from "@EMOrg-prd/react-standard";
import { useMsal } from "@azure/msal-react";
import { useCallback, useMemo, useState } from "react";
import { clients } from "../modules/Clients";
import { scopes } from "../modules/Scopes";
import { requestToken } from "../modules/AuthUtilities";
import CodeBox from "./CodeBox";
import TypeaheadField from "./TypeaheadField";

const environments = [
  { name: "Development", value: "development", layer: "outbound" as const },
  { name: "Acceptance", value: "acceptance", layer: "outbound" as const },
  { name: "Production", value: "production", layer: "outbound" as const },
];

const WebhookCredentialForm = () => {
  const { instance, accounts } = useMsal();
  const [clientId, setClientId] = useState("");
  const [environment, setEnvironment] = useState("");
  const [token, setToken] = useState("");

  const experienceClients = useMemo(
    () =>
      clients.filter(
        (client) =>
          client.layer === "experience" &&
          (client.environment as string[] | undefined)?.includes(environment)
      ),
    [environment]
  );
  const buttonDisabled = !clientId || !environment;
  const jwtLink = useMemo(() => `https://jwt.ms/#id_token=${token}`, [token]);

  const handleTokenRequest = useCallback(async () => {
    await requestToken(
      {
        clientId,
        scope: scopes.find((scope) => scope.layer === "experience")?.value ?? "",
        layer: "experience",
        clientName: experienceClients.find((client) => client.value === clientId)
          ?.name,
        dangerZoneRequest: true,
        environment,
      },
      setToken,
      { instance, account: accounts[0] }
    );
  }, [instance, accounts, clientId, environment, experienceClients]);

  return (
    <section className="danger-zone">
      <h2>Danger Zone</h2>
      <p>Request an Okta credential for webhook subscription maintenance.</p>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          await handleTokenRequest();
        }}
      >
        <TypeaheadField
          label="Environment"
          placeholder="Select environment"
          items={environments}
          value={environment}
          onChange={(value) => {
            setEnvironment(value);
            setClientId("");
          }}
          clearable
        />
        <TypeaheadField
          label="Webhook client"
          placeholder="Select an Experience Layer client"
          items={experienceClients}
          value={clientId}
          onChange={setClientId}
          disabled={!environment}
          clearable
        />
        <Button
          type="submit"
          variant="primary"
          style={{ width: "100%" }}
          disabled={buttonDisabled}
        >
          Request Okta Token
        </Button>
        <CodeBox
          value={token}
          placeholder="Select a client and environment, then request a token"
        />
        <a href={jwtLink} target="_blank" rel="noreferrer">
          <Button
            variant="secondary"
            style={{ width: "100%" }}
            size="small"
            disabled={!token}
          >
            View on jwt.ms
          </Button>
        </a>
      </form>
    </section>
  );
};

export default WebhookCredentialForm;